import { PatientConsult } from 'api/consult/types/consults.types';

import { CareProgram } from './careProgram.type';

export enum EligibilityStatus {
  NoCheckNeeded = 'no_check_needed',
  CheckNeeded = 'check_needed',
  Eligible = 'eligible',
  NotEligible = 'not_eligible',
  Pending = 'pending',
}

export enum PlanStatus {
  Active = 'active',
  Paused = 'paused',
  Terminated = 'terminated',
}

export const asEligible = (status: EligibilityStatus) =>
  status === EligibilityStatus.Eligible || status === EligibilityStatus.Pending;

export const preferredName = (patient: Patient) =>
  patient.nickname || patient.firstName;

export interface Patient {
  archivedAt: string;
  createdAt: string;
  internalId: string;
  id: string;
  firstName: string;
  lastName: string;
  nickname: string | null;
  dateOfBirth: string;
  age: number;
  sexAtBirth: string;
  gender: string;
  pronouns: string;
  ethnicity: string;
  streetAddress1: string;
  streetAddress2: string;
  city: string;
  state: string;
  zipCode: string;
  teenConsent: boolean | null;
  ayvaPharmacyUid: string;
  pharmacyNcpdpId: string;
  eligibilityStatus: EligibilityStatus;
  mrnSystem?: string;
  requiresGinaAuthorization: boolean;
  carePrograms?: CareProgram[];
  completedCarePrograms?: CareProgram[];
  benefits: [string];
  subscribableLink: string;
  personalAccountId?: string | null;
  planStatus: PlanStatus;
  insuranceCarrier?: string;
  financialResponsibilitySignedAt?: string;
  memberFinancialPolicySignedAt?: string;
  creditCardInfoProvided?: boolean;
  noShowCancellationPolicySignedAt?: string;
  sponsor?: {
    name: string;
  };
  termsAndConditionsSignedAt?: string;
  hasPatientCompletedConsult: boolean;
  consentToTreatMinor?: boolean;
  isC3hs: boolean;
  hsReferral?: object;
  recommendedPlan?: string;
  titleizedMrnSystem?: string | null;
  carePlanTasks?: CarePlanTask[] | null;
  newCarePlansForReview: number;
}

export interface CarePlanFile {
  acceptedAt: string;
  contentType: string;
  createdAt: string;
  documentType: string | null;
  fileUrl: string;
  id: string;
  name: string;
  patientId: string;
  signedId: string;
  storedFileName: string;
  updatedAt: string;
  task?: CarePlanTask;
  currentState: string;
  referenceDate: string;
}

export interface CarePlanTask {
  id: string;
  patientConsult?: PatientConsult;
  carePlanFile?: CarePlanFile;
  completerAvatar?: {
    id?: string;
    name?: string;
    url?: string;
  };
}

export const isMemberPaused = (member?: Patient) =>
  member?.planStatus === PlanStatus.Paused;
